import type { Nullish } from "@/types";

export const formatDateTime = (date: number | Date, locale: Nullish<string>, opts?: Intl.DateTimeFormatOptions) => {
    return new Intl.DateTimeFormat(locale ?? undefined, { dateStyle: "medium", timeStyle: "medium", ...opts }).format(
        date,
    );
};

export const formatDate = (date: number | Date, locale: Nullish<string>) => {
    return new Intl.DateTimeFormat(locale ?? undefined, { day: "2-digit", month: "2-digit", year: "2-digit" })
        .format(date)
        .replaceAll("-", "/");
};

export const formatShortDate = (date: number | Date, locale?: Nullish<string>) => {
    return new Intl.DateTimeFormat(locale ?? undefined, {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
    }).format(date);
};

export const getTypesAsString = (...types: string[]) => types.map((type) => `"${type}"`).join(" | ");

export const formatNumber = (value: number, locale?: Nullish<string>) => {
    return Intl.NumberFormat(locale ?? undefined, {}).format(value);
};

export const formatCompactNumber = (value: number, locale?: Nullish<string>) => {
    return Intl.NumberFormat(locale ?? undefined, { notation: "compact", compactDisplay: "short" }).format(value);
};
